const cookieBannerAcceptData = $(document.currentScript).data();

$('#cookieBannerAccept').on('click', function (e) {
	e.preventDefault();
	$.post(cookieBannerAcceptData.acceptUrl, function () {
		$('#cookie-banner').remove();
	});
});
